(function () {
  var rulesCache = null;
  var rulesPromise = null;

  function getLookcareScriptEl() {
    return document.querySelector('script[data-lookcare-rules-url]');
  }

  function getShopLocaleIso() {
    var script = getLookcareScriptEl();
    if (!script) return '';
    return String(script.getAttribute('data-lookcare-locale') || '')
      .trim()
      .toLowerCase();
  }

  function shouldLoadEnglishScenarioPack() {
    var loc = getShopLocaleIso();
    if (!loc) return false;
    if (loc === 'en') return true;
    if (loc.indexOf('en-') === 0) return true;
    if (loc.indexOf('en_') === 0) return true;
    return false;
  }

  function shouldLoadArabicScenarioPack() {
    var loc = getShopLocaleIso();
    if (!loc) return false;
    if (loc === 'ar') return true;
    if (loc.indexOf('ar-') === 0) return true;
    if (loc.indexOf('ar_') === 0) return true;
    return false;
  }

  function getEnglishScenarioPackUrl() {
    var script = getLookcareScriptEl();
    if (!script) return '';
    return String(script.getAttribute('data-lookcare-rules-locale-en-url') || '').trim();
  }

  function getArabicScenarioPackUrl() {
    var script = getLookcareScriptEl();
    if (!script) return '';
    return String(script.getAttribute('data-lookcare-rules-locale-ar-url') || '').trim();
  }

  function mergeLocaleScenarioPack(rules, pack) {
    if (!rules || !pack || !Array.isArray(pack.explicit_scenarios)) return rules;
    var map = {};
    for (var i = 0; i < pack.explicit_scenarios.length; i++) {
      var row = pack.explicit_scenarios[i];
      if (row && row.id) map[row.id] = row;
    }
    var list = rules.explicit_scenarios || [];
    for (var j = 0; j < list.length; j++) {
      var sc = list[j];
      var o = map[sc.id];
      if (!o) continue;
      if (o.routine_name) sc.routine_name = o.routine_name;
      if (o.support_plan) sc.support_plan = o.support_plan;
      if (o.output_line) sc.output_line = o.output_line;
      if (o.mock_description) sc.mock_description = o.mock_description;
      if (o.bundle_option) sc.bundle_option = o.bundle_option;
      if (o.product_reasons && typeof o.product_reasons === 'object') {
        sc.product_reasons = sc.product_reasons || {};
        var keys = Object.keys(o.product_reasons);
        for (var k = 0; k < keys.length; k++) {
          var pk = keys[k];
          if (o.product_reasons[pk]) sc.product_reasons[pk] = o.product_reasons[pk];
        }
      }
      if (typeof o.controlled_advanced === 'boolean') sc.controlled_advanced = o.controlled_advanced;
    }
    if (pack.result_ui && pack.result_ui.fallback_mock_description) {
      rules.result_ui = rules.result_ui || {};
      rules.result_ui.fallback_mock_description = pack.result_ui.fallback_mock_description;
    }
    return rules;
  }

  function applyOptionalLocaleScenarioPack(rules) {
    var enPackUrl = getEnglishScenarioPackUrl();
    if (shouldLoadEnglishScenarioPack() && enPackUrl) {
      return fetch(enPackUrl, { credentials: 'same-origin' })
        .then(function (res2) {
          if (!res2.ok) throw new Error('Failed to load lookcare-rules-locale-en.json');
          return res2.json();
        })
        .then(function (pack) {
          mergeLocaleScenarioPack(rules, pack);
          return rules;
        })
        .catch(function () {
          console.warn(
            'LookCare: English scenario strings were not applied; using default copy.'
          );
          return rules;
        });
    }
    var arPackUrl = getArabicScenarioPackUrl();
    if (shouldLoadArabicScenarioPack() && arPackUrl) {
      return fetch(arPackUrl, { credentials: 'same-origin' })
        .then(function (res2) {
          if (!res2.ok) throw new Error('Failed to load lookcare-rules-locale-ar.json');
          return res2.json();
        })
        .then(function (pack) {
          mergeLocaleScenarioPack(rules, pack);
          return rules;
        })
        .catch(function () {
          console.warn(
            'LookCare: Arabic scenario strings were not applied; using default copy.'
          );
          return rules;
        });
    }
    return Promise.resolve(rules);
  }

  function includesAny(list, values) {
    if (!Array.isArray(list) || !Array.isArray(values)) return false;
    for (var i = 0; i < values.length; i++) {
      if (list.indexOf(values[i]) !== -1) return true;
    }
    return false;
  }

  function matchesCondition(condition, answers) {
    if (!condition) return true;
    var keys = Object.keys(condition);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var expected = condition[key];
      var actual = answers[key];
      if (!actual || !Array.isArray(expected) || expected.indexOf(actual) === -1) {
        return false;
      }
    }
    return true;
  }

  function findExplicitScenario(rules, answers) {
    var list = rules.explicit_scenarios || [];
    for (var i = 0; i < list.length; i++) {
      var sc = list[i];
      if (sc && sc.match && matchesCondition(sc.match, answers)) return sc;
    }
    return null;
  }

  function getCatalogProductById(catalog, productId) {
    var products = (catalog && catalog.products) || [];
    for (var j = 0; j < products.length; j++) {
      if (products[j].id === productId) return products[j];
    }
    return null;
  }

  function isProductIdExcluded(productId, hardFilters, answers) {
    var exclusions = (hardFilters && hardFilters.product_exclusions) || [];
    for (var r = 0; r < exclusions.length; r++) {
      var rule = exclusions[r];
      if (!matchesCondition(rule.when, answers)) continue;
      var ids = rule.exclude_product_ids || [];
      if (ids.indexOf(productId) !== -1) return true;
    }
    return false;
  }

  function buildExplicitProductResults(explicit, catalog, hardFilters, answers) {
    var ids = explicit.product_ids || [];
    var reasons = (explicit && explicit.product_reasons) || {};
    var out = [];
    ids.forEach(function (pid, idx) {
      if (isProductIdExcluded(pid, hardFilters, answers)) return;
      var item = getCatalogProductById(catalog, pid);
      if (!item) return;
      var qr = reasons[pid];
      out.push({
        id: pid,
        item: item,
        score: 1000 - idx,
        order: idx,
        quiz_reason: typeof qr === 'string' && qr.trim() ? qr.trim() : null
      });
    });
    return out;
  }

  function scenarioForUi(explicit) {
    if (!explicit) return null;
    return {
      id: explicit.id,
      routine_name: explicit.routine_name || '',
      support_plan: explicit.support_plan || '',
      output_line: explicit.output_line || '',
      bundle_option: explicit.bundle_option || '',
      controlled_advanced: !!explicit.controlled_advanced,
      mock_description: explicit.mock_description || '',
      product_reasons:
        explicit.product_reasons && typeof explicit.product_reasons === 'object'
          ? explicit.product_reasons
          : null
    };
  }

  function createScoreMap(items) {
    var map = {};
    (items || []).forEach(function (item, idx) {
      if (!item || !item.id) return;
      map[item.id] = {
        item: item,
        score: 0,
        order: idx
      };
    });
    return map;
  }

  function applyScoringRules(targetMap, rules, answers, idField) {
    (rules || []).forEach(function (rule) {
      if (!matchesCondition(rule["if"], answers)) return;
      var addList = rule.add || rule.add_tip_ids || [];
      addList.forEach(function (entry) {
        var id = entry[idField];
        if (!id || !targetMap[id]) return;
        targetMap[id].score += Number(entry.score || 0);
      });
    });
  }

  function sortAndTake(scoreMap, take) {
    return Object.keys(scoreMap)
      .map(function (id) {
        return {
          id: id,
          item: scoreMap[id].item,
          score: scoreMap[id].score,
          order: scoreMap[id].order
        };
      })
      .filter(function (entry) {
        return entry.score > 0;
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.order - b.order;
      })
      .slice(0, Math.max(0, take || 0));
  }

  function applyProductExclusions(productMap, hardFilters, answers) {
    var exclusions = (hardFilters && hardFilters.product_exclusions) || [];
    exclusions.forEach(function (rule) {
      if (!matchesCondition(rule.when, answers)) return;
      (rule.exclude_product_ids || []).forEach(function (id) {
        if (productMap[id]) {
          delete productMap[id];
        }
      });
    });
  }

  function ensureContentRequirements(selectedContents, allContents, hardFilters, answers) {
    var requirements = (hardFilters && hardFilters.content_requirements) || [];
    var result = selectedContents.slice();
    requirements.forEach(function (rule) {
      if (!matchesCondition(rule.when, answers)) return;
      var mustTags = rule.must_include_content_tags || [];
      if (!mustTags.length) return;
      var hasRequired = result.some(function (entry) {
        return includesAny(entry.item.tags || [], mustTags);
      });
      if (hasRequired) return;
      var fallback = (allContents || []).find(function (entry) {
        return includesAny((entry.item && entry.item.tags) || [], mustTags);
      });
      if (fallback) {
        result.push(fallback);
      }
    });
    return result;
  }

  function withFallback(selected, fallbackIds, scoreMap, take) {
    var out = selected.slice();
    var needed = Math.max(0, (take || 0) - out.length);
    if (!needed) return out;
    for (var i = 0; i < (fallbackIds || []).length; i++) {
      var id = fallbackIds[i];
      var entry = scoreMap[id];
      if (!entry) continue;
      var exists = out.some(function (x) {
        return x.id === id;
      });
      if (exists) continue;
      out.push({
        id: id,
        item: entry.item,
        score: entry.score,
        order: entry.order
      });
      if (out.length >= take) break;
    }
    return out;
  }

  function evaluateFromRules(rules, answers) {
    answers = answers || {};
    var catalog = rules.catalog_map || {};
    var scoring = rules.scoring || {};
    var diversity = rules.diversity || {};
    var fallback = rules.fallback || {};
    var explicit = findExplicitScenario(rules, answers);

    var productMap = createScoreMap(catalog.products);
    var contentMap = createScoreMap(catalog.contents);
    var tipMap = createScoreMap(catalog.tips);

    applyScoringRules(contentMap, scoring.contents, answers, 'content_id');
    applyScoringRules(tipMap, scoring.tips, answers, 'tip_id');

    var productTake = (diversity.products && diversity.products.take) || 2;
    var contentTake = (diversity.contents && diversity.contents.take) || 2;
    var tipTake = (diversity.tips && diversity.tips.take) || 3;

    var selectedProducts;
    var scenario = null;

    if (explicit && explicit.product_ids && explicit.product_ids.length) {
      selectedProducts = buildExplicitProductResults(
        explicit,
        catalog,
        rules.hard_filters,
        answers
      );
      scenario = scenarioForUi(explicit);
      if (!selectedProducts.length) {
        selectedProducts = null;
        scenario = null;
      }
    }

    if (!selectedProducts) {
      applyProductExclusions(productMap, rules.hard_filters, answers);
      applyScoringRules(productMap, scoring.products, answers, 'product_id');
      selectedProducts = sortAndTake(productMap, productTake);
      selectedProducts = withFallback(selectedProducts, fallback.products, productMap, productTake);
    }

    var selectedContents = sortAndTake(contentMap, contentTake);
    var allContentSorted = sortAndTake(contentMap, 999);
    selectedContents = ensureContentRequirements(selectedContents, allContentSorted, rules.hard_filters, answers)
      .slice(0, contentTake);
    var selectedTips = sortAndTake(tipMap, tipTake);

    selectedContents = withFallback(selectedContents, fallback.contents, contentMap, contentTake);
    selectedTips = withFallback(selectedTips, fallback.tips, tipMap, tipTake);

    var fallbackMock =
      (rules.result_ui && rules.result_ui.fallback_mock_description) || '';
    var resultMockDescription = fallbackMock;
    if (scenario && explicit && explicit.mock_description) {
      resultMockDescription = explicit.mock_description;
    }

    selectedProducts = (selectedProducts || []).map(function (p) {
      if (p.quiz_reason) return p;
      var item = p.item;
      var qr =
        item &&
        (item.quiz_default_reason || item.result_long_reason || item.result_short_reason);
      qr = qr ? String(qr).trim() : '';
      return {
        id: p.id,
        item: p.item,
        score: p.score,
        order: p.order,
        quiz_reason: qr || null
      };
    });

    return {
      answers: answers,
      products: selectedProducts,
      contents: selectedContents,
      tips: selectedTips,
      scenario: scenario,
      result_mock_description: resultMockDescription
    };
  }

  function getRulesUrl() {
    var script = getLookcareScriptEl();
    if (script) return script.getAttribute('data-lookcare-rules-url');
    return '/assets/lookcare-rules.json';
  }

  function loadRules() {
    if (rulesCache) return Promise.resolve(rulesCache);
    if (rulesPromise) return rulesPromise;
    var url = getRulesUrl();
    rulesPromise = fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load lookcare-rules.json');
        return res.json();
      })
      .then(function (rules) {
        return applyOptionalLocaleScenarioPack(rules);
      })
      .then(function (rules) {
        rulesCache = rules;
        return rulesCache;
      })
      .catch(function () {
        rulesPromise = null;
        throw new Error('LookCare rules load failed');
      });
    return rulesPromise;
  }

  window.LookcareEngine = {
    loadRules: loadRules,
    evaluate: function (answers) {
      return loadRules().then(function (rules) {
        try {
          return evaluateFromRules(rules, answers);
        } catch (e) {
          console.error('LookCare Engine evaluation failed:', e);
          throw e;
        }
      });
    },
    evaluateSync: function (answers) {
      if (!rulesCache) {
        throw new Error('Rules not loaded yet. Call LookcareEngine.loadRules() first.');
      }
      return evaluateFromRules(rulesCache, answers);
    }
  };
})();
